import { render, staticRenderFns } from "./NotificationsWidget.vue?vue&type=template&id=4db16f4b&"
import script from "./NotificationsWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationsWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports